import { createSelector } from 'reselect';

const selectWebsites = (state: any) => state.websites;


export const selectCurrentItem = createSelector([selectWebsites], (websites) => websites.current);

export const selectWebsiteListItems = createSelector([selectWebsites], (websites) => websites.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectWebsiteListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectWebsiteQueryItems = createSelector([selectWebsites], (websites) => websites.query);

export const selectCreatedItem = createSelector([selectWebsites], (websites) => websites.create);

export const selectUpdatedItem = createSelector([selectWebsites], (websites) => websites.update);

export const selectReadItem = createSelector([selectWebsites], (websites) => websites.read);

export const selectDeletedItem = createSelector([selectWebsites], (websites) => websites.delete);

export const selectSearchedItems = createSelector([selectWebsites], (websites) => websites.search);

export const selectItemsCount = createSelector([selectWebsites], (websites) => websites.count);

export const selectItemsFilter = createSelector([selectWebsites], (websites) => websites.filter);